import { useEffect, useState } from "react";

export interface FetchState<T> {
    data: T | null;
    loading: boolean;
    error: Error | null;
}

export const useFetch = <T,>(url: string, path: string): FetchState<T> => {
    const [data, setData] = useState<T | null>(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<Error | null>(null);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await fetch(`https://${url}${path}`);
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                const data: T = await response.json();
                setData(data);
            } catch (error) {
                setError(error as Error);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, [url, path]);

    return { data, loading, error };
};
